/**
 * ErrorFallback — shown when a React render error crashes the app.
 *
 * Mounted via Sentry.ErrorBoundary in main.tsx. Kept minimal and
 * i18n-aware so users at MUNI see a localized message even in the
 * worst-case failure mode.
 */

import { useTranslation } from 'react-i18next'
import { Button } from './ui'

interface ErrorFallbackProps {
	error: unknown
	resetError: () => void
}

export function ErrorFallback({ resetError }: ErrorFallbackProps) {
	const { t } = useTranslation()

	return (
		<div role="alert" className="min-h-screen flex items-center justify-center bg-base-200 px-4">
			<div className="max-w-md w-full bg-base-100 rounded-2xl shadow-soft p-8 text-center">
				<h1 className="text-2xl font-display mb-3">{t('errors.fallback.title')}</h1>
				<p className="text-base-content/70 mb-6">{t('errors.fallback.description')}</p>
				<Button onClick={resetError}>{t('errors.fallback.retry')}</Button>
			</div>
		</div>
	)
}
